import { QuestionConfirmPage, ConfirmType } from 'views/pages/compatibilityCheck/questions/questionConfirm';
import { useCompatibilityCheck } from 'views/pages/compatibilityCheck/hooks';
import {
  useCompatibilityStartConfirm,
  CompatibilityCheckConditionType,
} from 'views/pages/compatibilityCheck/questions/questionConfirm/questionStartConfirm/hooks';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { ProductType, ProductTypeMap } from 'constants/productType';
import { AccountTabs } from 'views/mutual/tabs/accountTabs';

type ConfirmCompatibilityCheckProps = {
  assetType: ProductType;
};

// メニュー項目から遷移してくる場合はこちらを表示
export const ConfirmCompatibilityCheckHome = () => {
  const tabItems = [
    {
      title: ProductTypeMap[ProductType.LeaseFund].name,
      content: <ConfirmCompatibilityCheck assetType={ProductType.LeaseFund} />,
      productType: ProductType.LeaseFund,
    },
    {
      title: ProductTypeMap[ProductType.DomesticRealEstate].name,
      content: <ConfirmCompatibilityCheck assetType={ProductType.DomesticRealEstate} />,
      productType: ProductType.DomesticRealEstate,
    },
    {
      title: ProductTypeMap[ProductType.OverseasRealEstate].name,
      content: <ConfirmCompatibilityCheck assetType={ProductType.OverseasRealEstate} />,
      productType: ProductType.OverseasRealEstate,
    },
  ];

  return (
    <div className="confirmCompatibilityCheck">
      <AccountTabs tabItems={tabItems} />
    </div>
  );
};

export const ConfirmCompatibilityCheck = ({ assetType }: ConfirmCompatibilityCheckProps) => {
  const { questionToAnswers, setAnswers } = useCompatibilityCheck(assetType);
  const compatibilityStartConfirm = useCompatibilityStartConfirm(
    setAnswers,
    CompatibilityCheckConditionType.ExpirationCheck,
    assetType,
  );
  return (
    <LoadingContainer isLoading={compatibilityStartConfirm.compatibility.fetching} size={LoadingSize.Medium}>
      <QuestionConfirmPage questionToAnswers={questionToAnswers} confirmType={ConfirmType.OnlyConfirm} />
    </LoadingContainer>
  );
};
